import { ArrowLeft } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { manualIndexPath } from '../../helpers/manualPath';
import { getManualSection } from './manualRegistry';
import './manual.scss';

/**
 * The `/readme/:slug` section page (TRIL-424). Looks the slug up in the manual
 * registry and renders its content component; an unknown slug renders a
 * not-found with a link back to the index. Auth-gating is handled by the route
 * being registered as private in `privateRoutes.constants.ts`.
 */
export default function ManualSectionRoute() {
  const { slug } = useParams<{ slug: string }>();
  const section = slug ? getManualSection(slug) : undefined;

  if (!section) {
    return (
      <div className="MANUAL MANUAL--state">
        <Link to={manualIndexPath()} className="MANUAL__BACK">
          <ArrowLeft size={16} aria-hidden="true" /> Manual
        </Link>
        <p>That manual page doesn&apos;t exist.</p>
      </div>
    );
  }

  const { title, Component } = section;

  return (
    <article className="MANUAL">
      <Link to={manualIndexPath()} className="MANUAL__BACK">
        <ArrowLeft size={16} aria-hidden="true" /> Manual
      </Link>
      <header className="MANUAL__HEADER">
        <span className="MANUAL__EYEBROW">User Manual</span>
        <h1 className="MANUAL__TITLE">{title}</h1>
      </header>
      <Component />
    </article>
  );
}
